import React, { useState } from "react";
import MapGL, { Marker } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { useData } from "../util/dataProvider";
import MarkerDetails from "./MarkerDetails";
import ExpertDetails from "./ExpertDetails";
import { Link } from "react-router-dom";
import * as turf from "@turf/turf";
import Closered from "../images/closered.svg";

export default function Map({ active }) {
    const {
        filteredUnternehmen,
        filteredExperten,
        getCatLabel,
        getColor,
        assetUrl,
    } = useData();
    const [detailsShow, setDetailsShow] = useState(false);

    const [viewState, setViewState] = useState({
        longitude: 7.083141,
        latitude: 51.170208,
        zoom: 9,
    });
    return (
        <div className='map'>
            <MapGL
                mapboxApiAccessToken='pk.eyJ1IjoiZ3JvZXYiLCJhIjoiY2syMjBxODEyMG0xZjNnbnlheDBodnFvZSJ9.IEDAGVWLoHBn_4iV419Tlw'
                {...viewState}
                width='100%'
                height='70vh'
                onViewStateChange={(evt) => setViewState(evt.viewState)}
                style={{ width: "100%", height: "70vh" }}
                mapStyle='mapbox://styles/mapbox/streets-v9'>
                {(active === "unternehmen" || active === "all") &&
                    filteredUnternehmen &&
                    filteredUnternehmen.map((company, idx) => {
                        let lat = company.location?.lat;
                        let lng = company.location?.lng;
                        if (!lat || !lng) {
                            lat = 51.170208;
                            lng = 7.083141;
                        }
                        return (
                            <Marker
                                key={idx}
                                longitude={parseFloat(lng)}
                                latitude={parseFloat(lat)}
                                anchor='bottom'>
                                <div
                                 className={company.id === detailsShow.id ? 'marker-none' : 'marker-all'}
                                    onClick={() => {
                                        setDetailsShow(company);
                                    }}>
                                    <MarkerDetails
                                        detailsShow={detailsShow}
                                        company={company}
                                    />
                                </div>
                            </Marker>
                        );
                    })}
                {active === "forschung" &&
                    filteredUnternehmen &&
                    filteredUnternehmen.map((company, idx) => {
                        let lat = company.location?.lat;
                        let lng = company.location?.lng;
                        if (!lat || !lng) {
                            lat = 51.170208;
                            lng = 7.083141;
                        }
                        if (company.category === "forschung") {
                            return (
                                <Marker
                                    key={idx}
                                    longitude={parseFloat(lng)}
                                    latitude={parseFloat(lat)}
                                    anchor='bottom'>
                                    <div
                                    className={company.id === detailsShow.id ? 'marker-none' : 'marker-all'}
                                        onClick={() => setDetailsShow(company)}>
                                        <MarkerDetails
                                            detailsShow={detailsShow}
                                            company={company}
                                        />
                                    </div>
                                </Marker>
                            );
                        }
                    })}
                {active === "startup" &&
                    filteredUnternehmen &&
                    filteredUnternehmen.map((company, idx) => {
                        let lat = company.location?.lat;
                        let lng = company.location?.lng;
                        if (!lat || !lng) {
                            lat = 51.170208;
                            lng = 7.083141;
                        }
                        if (company.category === "startup") {
                            return (
                                <Marker
                                    key={idx}
                                    longitude={parseFloat(lng)}
                                    latitude={parseFloat(lat)}
                                    anchor='bottom'>
                                    <div
                                    className={company.id === detailsShow.id ? 'marker-none' : 'marker-all'}
                                        onClick={() => setDetailsShow(company)}>
                                        <MarkerDetails
                                            detailsShow={detailsShow}
                                            company={company}
                                        />
                                    </div>
                                </Marker>
                            );
                        }
                    })}

                {(active === "experten" || active === "all") &&
                    filteredExperten &&
                    filteredExperten.map((expert, idx) => {
                        let lat = expert.location?.lat;
                        let lng = expert.location?.lng;
                        if (!lat || !lng) {
                            lat = 51.170208;
                            lng = 7.083141;
                        }
                        console.log(expert,detailsShow)
                        let tet = "all";
                       
                        return (
                            <Marker
                                key={idx}
                                longitude={parseFloat(lng)}
                                latitude={parseFloat(lat)}
                                anchor='bottom'>
                                <div
                                className={expert.id === detailsShow.id ? 'marker-none' : 'marker-all'}
                                
                                onClick={() => setDetailsShow(expert)}>
                             
                                    <ExpertDetails
                                        detailsShow={detailsShow}
                                        expert={expert}
                                    />
                                </div>
                            </Marker>
                        );
                    })}
            </MapGL>
            {detailsShow && detailsShow.long_name && (
                <div
                    className='details'
                    style={{
                        zIndex: detailsShow ? 9999 : 0,
                        position: "absolute",
                    }}>
                    <div
                        className='close-red'
                        style={{
                            backgroundImage: `url(${assetUrl + Closered})`,
                        }}
                        onClick={() => setDetailsShow(false)}></div>

                    <div>
                        <div className='name'>{detailsShow.name}</div>
                        <div className='thema'>
                            {getCatLabel(detailsShow.category)}
                        </div>
                    </div>
                    <Link
                        style={{ color: getColor(detailsShow.category) }}
                        to={`/company/${detailsShow.id}`}>
                        Zum Profil
                    </Link>
                </div>
            )}
            {detailsShow && detailsShow.firstname && (
                <div
                    className='details'
                    style={{
                        zIndex: detailsShow ? 9999 : 0,
                        position: "absolute",
                    }}>
                    <div
                        className='close-red'
                        style={{
                            backgroundImage: `url(${assetUrl + Closered})`,
                        }}
                        onClick={() => setDetailsShow(false)}></div>
                    <div>
                        <div className='name'>
                            {detailsShow.firstname} {detailsShow.lastname}
                        </div>
                        <div className='thema'>
                            {getCatLabel(detailsShow.category)}
                        </div>
                    </div>
                    <Link
                        style={{ color: getColor(detailsShow.category) }}
                        to={`/expert/${detailsShow.id}`}>
                        Zum Profil
                    </Link>
                </div>
            )}
        </div>
    );
}
